import { gql } from "@apollo/client";

export const GetOrganization = gql`
  query GetOrganization($id: String!) {
    organizationOne(id: $id) {
      id
      name
      description
      logoUrl
      street
      zipCode
      city
      country
      state
      categoryOptions {
        id
        name
        type
        isActive
      }
      locations {
        id
        name
        description
        logoUrl
        stationsEnabled
      }
      organizationBranding {
        brandingLogoImg
        id
        primaryColor
        secondaryColor
      }
    }
  }
`;

export const GetOrganizationPage = gql`
  query GetOrganizationPage($pagination: PaginationInput!) {
    organizationPage(pagination: $pagination) {
      items {
        id
        name
        description
        logoUrl
        createdDate
      }
      totalRows
    }
  }
`;

export const GetOrganizationRevenueFee = gql`
  query GetOrganizationRevenueFee($id: String!) {
    organizationOne(id: $id) {
      id
      locations {
        id
        name
        logoUrl
        locationRevenue {
          payrocAccount {
            id
            merchantId
            payrocVirtualTerminalId
            payrocEmbeddedSecret
          }
          id
        }
      }
    }
  }
`;
